import "./VideoProjectGallery.css";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { listS3Files, getMediaType } from "../config/aws";
import VideoPlayer from "./../components/VideoPlayer";

function VideoProjectGallery({ projectId }) {
  const { slug } = useParams();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    listS3Files(`gallery/videos/${slug}/fullscale`).then(setFiles);
  }, [slug]);

  return (
    <div className="video-project-main-div">
      <div className="video-project-content-div">
        <div className="video-project-images-grid">
          {files
            .filter((url) => getMediaType(url) === "image")
            .map((url, index) => (
              <img key={url} src={url} alt={`Capture d'écran du projet ${index + 1}`} className="video-project-img" />
            ))}
        </div>
        {files
          .filter((url) => getMediaType(url) === "video")
          .map((url) => (
            <VideoPlayer key={url} src={url} />
          ))}
      </div>
    </div>
  );
}

export default VideoProjectGallery;
